import { configureStore } from "@reduxjs/toolkit";
import snapshotReducer from "./snapshot";

export default configureStore({
  reducer: {
    snapshot: snapshotReducer,
  },
});
